import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const comments = [
  {
    id: 1,
    author: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20casual%20portrait%20avatar%2C%20simple%20warm%20lighting%2C%20clean%20background%2C%20friendly%20expression&width=80&height=80&seq=comment-avatar-01&orientation=squarish',
    handle: '@nightmelon',
    content: '这个瓜我吃定了！内幕消息太劲爆了，没想到平时看起来那么清纯的明星私下竟然是这样...建议大家理性吃瓜，不要人身攻击哦。',
  },
  {
    id: 2,
    author: '吃瓜群众小张',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20casual%20portrait%20avatar%2C%20simple%20warm%20lighting%2C%20clean%20background%2C%20friendly%20expression&width=80&height=80&seq=comment-avatar-02&orientation=squarish',
    handle: '@melonzhang',
    content: '我室友在这个剧组工作过，他说的情况比爆料的还要夸张十倍！导演是真的难伺候，全剧组都怕他。',
  },
  {
    id: 3,
    author: '理性吃瓜者',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Asian%20woman%20portrait%20avatar%2C%20simple%20warm%20lighting%2C%20clean%20background%2C%20calm%20expression&width=80&height=80&seq=comment-avatar-03&orientation=squarish',
    handle: '@lixingua',
    content: '建议大家先别急着站队，等更多证据出来再判断。现在网上反转的事情还少吗？让子弹飞一会儿。',
  },
  {
    id: 4,
    author: '瓜田守望者',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20person%20casual%20portrait%20avatar%2C%20simple%20warm%20lighting%2C%20clean%20background%2C%20playful%20expression&width=80&height=80&seq=comment-avatar-04&orientation=squarish',
    handle: '@melonwatcher',
    content: '新来的朋友们记住：吃瓜不站队，站队不吃瓜。我们只是瓜田里的守望者，默默看戏就好。',
  },
  {
    id: 5,
    author: '八卦小能手',
    avatar: 'https://readdy.ai/api/search-image?query=Casual%20Asian%20young%20woman%20portrait%20avatar%2C%20simple%20warm%20lighting%2C%20clean%20background%2C%20fun%20expression&width=80&height=80&seq=comment-avatar-05&orientation=squarish',
    handle: '@gossipmaster',
    content: '我听说还有更猛的料没爆出来，据说涉及好几个一线明星。这个圈子真的比电视剧还精彩！',
  },
  {
    id: 6,
    author: '互联网活化石',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20Asian%20man%20portrait%20avatar%2C%20simple%20warm%20lighting%2C%20clean%20background%2C%20wise%20expression&width=80&height=80&seq=comment-avatar-06&orientation=squarish',
    handle: '@netfossil',
    content: '混迹互联网20年，这种瓜见得多了。不过这次确实有点意思，感觉后面还会有大反转。',
  },
];

export default function WaterfallSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-10">
          <span className="inline-block bg-accent-500 text-background-50 text-xs px-3 py-1 rounded-full mb-4">
            网友爆料
          </span>
          <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 font-black leading-tight">
            吃瓜前线
            <br />
            热评如潮
          </h2>
        </div>

        {/* Masonry grid - 3 columns */}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 space-y-5">
          {comments.map((comment, idx) => (
            <div
              key={comment.id}
              className="break-inside-avoid bg-background-50 rounded-lg p-5 hover:bg-background-50/90 transition-colors"
            >
              {/* Author info */}
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-accent-100">
                  <img
                    src={comment.avatar}
                    alt={comment.author}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-bold text-foreground-950">{comment.author}</p>
                  <p className="text-xs text-foreground-500">{comment.handle}</p>
                </div>
              </div>
              {/* Comment content */}
              <p className="text-sm text-foreground-700 leading-relaxed">
                &ldquo;{comment.content}&rdquo;
              </p>
              {/* Related article link */}
              {idx < articles.length && (
                <Link
                  to={`/article/${articles[idx].id}`}
                  className="inline-block mt-3 text-xs text-accent-500 hover:text-accent-600 font-medium"
                >
                  查看相关爆料 →
                </Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}